import baseRequest, { baseRequestBackendTs } from "./baseRequest";

export const getAllCashlessPhysiotherapyRequests = (params = {}) => {
    const url = "/physio/ops/order-listing";
    const method = "GET";
    
    const data = null;
    
    // Use the baseRequest function
   return baseRequestBackendTs(url, method, params, data);
}

export const confirmRequest = (requestId) => {
    const url = `/physio/ops/confirm/${requestId}`
    const method = 'POST'

    return baseRequestBackendTs(url, method, null, {})
}

export const cancelRequest = (requestId, reason, remarks) => {
    const url = `/physio/ops/cancel/${requestId}`
    const method = 'POST'
    const data = {
        cancelReason: reason,
        remarks
    }

    return baseRequestBackendTs(url, method, null, data)
}

export const callUserPhysiotherapyRequest = (requestId, regarding) => {
    const url = `/physio/ops/call/${requestId}`;
    const method = 'POST';
    const data = {
      regarding,
    };
    return baseRequestBackendTs(url, method, null, data);
};

export const getPhysiotherapyRequest = (requestId) => {
    const url = `/physio/ops/details/${requestId}`
    const method = 'GET'
  
    return baseRequestBackendTs(url, method, null, null)
}

export const requestPhysiotherapyPayment = (requestId) => {
    const url = `/physio/ops/request-payout/${requestId}`
    const method = 'GET'
    const data = {
        requestId
    }
    return baseRequest(url, method, null, data)
}

export const claimPhysiotherapyRequest = (requestId) => {
    if (!requestId) {
      throw new Error('No Request Id Found');
    }
    const url = `/physio/ops/claim/${requestId}`;
    const method = 'POST';
    return baseRequest(url, method, null, null);
};

export const shiftPhysiotherapyRequest = (requestId) => {
    if (!requestId) {
        throw new Error('No Request Id Found');
      }
      const url = `/physio/ops/shift/${requestId}`;
      const method = 'POST';
      return baseRequest(url, method, null, null);
}

export const getPhysiotherapyRequestStatus = (requestId) => {
    const url = `/physio/ops/request-status/${requestId}`
    const method = 'GET'
    return baseRequest(url, method, null, null)
}

export const getPhysiotherapyRequestComments = (requestId) => {
    const url = `/physio/ops/comment/${requestId}`
    const method = 'GET'
    return baseRequestBackendTs(url, method, null, null)
}

export const storePhysiotherapyComment = (requestId, comment, type = 'internal') => {
    const url = `/physio/ops/comment/${requestId}`
    const method = 'POST'
    const data = { comment, type }
    return baseRequestBackendTs(url, method, null, data)
}

export const getPhysiotherapyRequestHistory = (requestId) => {
    const url = `/physio/ops/history/${requestId}`
    const method = 'GET'
    return baseRequestBackendTs(url, method, null, null)
}

export const resendCashlessLetter = (requestId) => {
    const url = `/physio/ops/resend-letter/${requestId}`
    const method = 'GET'
    return baseRequest(url, method, null, null)
}

export const generateCashlessLetter = (requestId) => {
    const url = `/physio/ops/generate-cashless-letter/${requestId}`
    const method = 'POST'
    return baseRequestBackendTs(url, method, null, {})
}
